module.exports = __webpack_public_path__ + "img/esquina_amarilla.ba1c6f5b.svg";